// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface addOnlineCourseToCartRequestPayload {
  id: number;
  callback: Function;
}
export interface addOnlineCourseToCartSuccessPayload {}

export interface addOnlineCourseToCartFailPayload {
  error: Error;
}

export const addOnlineCourseToCartActions = createAsyncAction(
  'elearning/ADD_ONLINE_COURSE_TO_CART',
  'elearning/ADD_ONLINE_COURSE_TO_CART_SUCCESS',
  'elearning/ADD_ONLINE_COURSE_TO_CART_FAIL'
)<
  addOnlineCourseToCartRequestPayload,
  addOnlineCourseToCartSuccessPayload,
  addOnlineCourseToCartFailPayload
>();
